require('./style.css');
let Event = require('f.core.event');

let ua = navigator.userAgent.toLowerCase();
let isIphone = ua.indexOf('iphone') >= 0 ? true : false;
window.currentVideo = '';

let Events = [
    'loadstart',
    'suspend',
    'abort',
    'error',
    'emptied',
    'stalled',
    'loadedmetadata',
    'loadeddata',
    'canplay',
    'canplaythrough',
    'playing',
    'waiting',
    'seeking',
    'seeked',
    'ended',
    'durationchange',
    'timeupdate',
    'progress',
    'play',
    'pause',
    'ratechange',
    'volumechange'
];

let toTitleCase = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

let setAttribute = function(el, name, val) {
    el.setAttribute(name, val);
};

let loadVideo = function(el) {
    if (typeof el.load === 'function') {
        // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
        (function() {
            try {
                el.load();
            } catch (e) {
                // satisfy linter
            }
        })();
    }
};

let resetVideo = function(el) {
    if (!el) {
        return;
    }

    let sources = el.querySelectorAll('source');
    let i = sources.length;

    while (i--) {
        el.removeChild(sources[i]);
    }

    // remove any src reference.
    // not setting `src=''` because that throws an error
    el.removeAttribute('src');
    loadVideo(el);
};

let createVideo = function(options) {
    let el = document.createElement('video');
    el.play_new = el.play; // 重新命名play方法，猎豹浏览器会劫持video的play方法
    if (isIphone) {
        setAttribute(el, 'preload', 'meta');
    } else {
        setAttribute(el, 'preload', 'auto');
    }

    // setAttribute(el, 'preload', 'none');

    el.className = 'c-video__meta';

    if (options.inline) {
        setAttribute(el, 'playsinline', 'playsinline');
        setAttribute(el, 'webkit-playsinline', 'webkit-playsinline');
    }
    if (options.muted) {
        setAttribute(el, 'muted', 'muted');
    }
    if (options.controls) {
        setAttribute(el, 'controls', 'true');
    }
    if (options.autoplay) {
        setAttribute(el, 'autoplay', 'autoplay');
    }
    if (options.poster) {
        // setAttribute(el, 'poster', options.poster);
    }
    if (options.loop) {
        setAttribute(el, 'loop', 'loop');
    }
    setAttribute(el, 'src', options.src);
    loadVideo(el);
    el.width = options.width;
    return el;
};

let Core = function(options) {
    this.init(options);
};

Core.prototype.init = function(options) {
    this.event = new Event();
    this.__isPlayed = false;
    this.__uuid = uuid();
    regVideo(this);
    this.el = createVideo(options);
    this.initEvent();
};

/**
 * custom Event
 * begin 当一个视频源第一次播放的时候，会触发一次此事件。
 * swtich 当使用src()播放另外一个视频的时候，会触发一次此事件，有两个参数oldsrc, newsrc
 */
Core.prototype.initEvent = function() {
    // 对视频的第一次播放进行处理
    let begin = function(event) {
        if (this.__isPlayed == false) {
            this.__isPlayed = true;
            this.event.trigger('begin');
        }
    }.bind(this);

    this.on('timeupdate', begin);

    this.on('playing', function() {
        console.log('playing');
        currentVideo = this;
    });

    this.el.addEventListener(
        'waiting',
        (event) => {
            console.log('change Current time ^^^^^^^^^^');
            let elm = event.target;
            console.log('currentTime:', elm.currentTime, '@@@@@@@@@@');
            if (elm.currentTime < 1) {
                console.log('forceChange Current Time!!!!!!!!!!');
                elm.currentTime = 0.1;
            }
        },
        false
    );

    let waitingEvent = [
        ['seeking', 'waitingStatus'],
        // ['stalled', 'waitingStatus'],
        ['waiting', 'waitingStatus'],
        ['seeked', 'waitingStatus'],
        ['play', 'waitingStatus'],
        ['playing', 'playingStatus'],
        ['timeupdate', 'playingStatus'],
        ['pause', 'pauseStatus'],
        ['ended', 'endStatus'],
        ['error', 'errorStatus']
    ];
    waitingEvent.forEach(([eventName, status]) => {
        // console.log(eventName);
        this.on(eventName, (e) => {
            // console.log(eventName, '=======>', status);
            this.event.trigger(status, e);
        });
    });
    let __this = this;
    Events.forEach(function(eventName) {
        (function(evnetName) {
            __this.on(eventName, function() {
                // divLog(eventName, 'is fire');
                //  console.log(eventName, 'is fire');
            });
        })(eventName);
    });
};

Core.prototype.on = function(eventName, callback) {
    if (Events.indexOf(eventName) >= 0) {
        this.el.addEventListener(eventName, callback, false);
    } else {
        this.event.on(eventName, callback);
    }
};

Core.prototype.off = function(eventName, callback) {
    if (Events.indexOf(eventName) >= 0) {
        this.el.removeEventListener(eventName, callback);
    } else {
        this.event.off(eventName, callback);
    }
};

Core.prototype.pause = function() {
    this.el.pause();
};

Core.prototype.play = function() {
    let playPromise = this.el.play_new();
    // Catch/silence error when a pause interrupts a play request
    // on browsers which return a promise
    if (playPromise !== undefined && typeof playPromise.then === 'function') {
        playPromise.then(null, function(e) {});
    }
};

Core.prototype.setCurrentTime = function(seconds) {
    try {
        this.el.currentTime = seconds;
    } catch (e) {
        console.log(e, 'Video is not ready. (Video.js)');
        // this.warning(VideoJS.warnings.videoNotReady);
    }
};

Core.prototype.getCurrentTime = function() {
    return this.el.currentTime;
};

Core.prototype.load = function() {
    loadVideo(this.el);
};

Core.prototype.reset = function() {
    resetVideo(this.el);
    this.__isPlayed = false;
};

Core.prototype.src = function(src) {
    if (src === undefined) {
        return this.el.src;
    }

    this.reset();
    this.event.trigger('switch', this.el.src, src);
    setAttribute(this.el, 'src', src);
};

Core.prototype.renderTo = function(container) {
    container.appendChild(this.el);
};

Core.prototype.destory = function() {
    // 解除所有事件绑定
    Events.forEach(
        function(eventName) {
            this.off(eventName);
        }.bind(this)
    );
    this.off('begin');
    this.off('switch');

    // 重置
    this.reset();

    // 移除dom节点。
    if (this.el.parentNode) {
        this.el.parentNode.removeChild(this.el);
    }

    // 取消在全局的注册
    unRegVideo(this);
};

[
    /**
     * Paused for core tech
     *
     * @method Core.prototype.paused
     * @return {Boolean}
     */
    'paused',
    /**
     * Get current time
     *
     * @method Core.prototype.currentTime
     * @return {Number}
     */
    'currentTime',
    /**
     * Get a TimeRange object that represents the intersection
     * of the time ranges for which the user agent has all
     * relevant media
     *
     * @return {TimeRangeObject}
     * @method Core.prototype.buffered
     */
    'buffered',
    /**
     * Get volume level
     *
     * @return {Number}
     * @method Core.prototype.volume
     */
    'volume',
    /**
     * Get if muted
     *
     * @return {Boolean}
     * @method Core.prototype.muted
     */
    'muted',
    /**
     * Get poster
     *
     * @return {String}
     * @method Core.prototype.poster
     */
    'poster',
    /**
     * Get preload attribute
     *
     * @return {String}
     * @method Core.prototype.preload
     */
    'preload',
    /**
     * Get autoplay attribute
     *
     * @return {String}
     * @method Core.prototype.autoplay
     */
    'autoplay',
    /**
     * Get controls attribute
     *
     * @return {String}
     * @method Core.prototype.controls
     */
    'controls',
    /**
     * Get loop attribute
     *
     * @return {String}
     * @method Core.prototype.loop
     */
    'loop',
    /**
     * Get error value
     *
     * @return {String}
     * @method Core.prototype.error
     */
    'error',
    /**
     * Get whether or not the player is in the "seeking" state
     *
     * @return {Boolean}
     * @method Core.prototype.seeking
     */
    'seeking',
    /**
     * Get a TimeRanges object that represents the
     * ranges of the media resource to which it is possible
     * for the user agent to seek.
     *
     * @return {TimeRangeObject}
     * @method Core.prototype.seekable
     */
    'seekable',
    /**
     * Get if video ended
     *
     * @return {Boolean}
     * @method Core.prototype.ended
     */
    'ended',
    /**
     * Get the value of the muted content attribute
     * This attribute has no dynamic effect, it only
     * controls the default state of the element
     *
     * @return {Boolean}
     * @method Core.prototype.defaultMuted
     */
    'defaultMuted',
    /**
     * Get desired speed at which the media resource is to play
     *
     * @return {Number}
     * @method Core.prototype.playbackRate
     */
    'playbackRate',
    /**
     * Returns a TimeRanges object that represents the ranges of the
     * media resource that the user agent has played.
     * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-played
     *
     * @return {TimeRangeObject} the range of points on the media
     *                           timeline that has been reached through
     *                           normal playback
     * @method Core.prototype.played
     */
    'played',
    /**
     * Get the current state of network activity for the element, from
     * the list below
     * - NETWORK_EMPTY (numeric value 0)
     * - NETWORK_IDLE (numeric value 1)
     * - NETWORK_LOADING (numeric value 2)
     * - NETWORK_NO_SOURCE (numeric value 3)
     *
     * @return {Number}
     * @method Core.prototype.networkState
     */
    'networkState',
    /**
     * Get a value that expresses the current state of the element
     * with respect to rendering the current playback position, from
     * the codes in the list below
     * - HAVE_NOTHING (numeric value 0)
     * - HAVE_METADATA (numeric value 1)
     * - HAVE_CURRENT_DATA (numeric value 2)
     * - HAVE_FUTURE_DATA (numeric value 3)
     * - HAVE_ENOUGH_DATA (numeric value 4)
     *
     * @return {Number}
     * @method Core.prototype.readyState
     */
    'readyState',
    /**
     * Get width of video
     *
     * @return {Number}
     * @method Core.prototype.videoWidth
     */
    'videoWidth',
    /**
     * Get height of video
     *
     * @return {Number}
     * @method Core.prototype.videoHeight
     */
    'videoHeight',
    'duration'
].forEach(function(prop) {
    Core.prototype['get' + toTitleCase(prop)] = function() {
        return this.el[prop];
    };
});

// Wrap native properties with a setter in this format:
// set + toTitleCase(name)
[
    /**
     * Set volume level
     *
     * @param {Number} percentAsDecimal Volume percent as a decimal
     * @method Core.prototype.setVolume
     */
    'volume',
    /**
     * Set muted
     *
     * @param {Boolean} muted If player is to be muted or note
     * @method Core.prototype.setMuted
     */
    'muted',
    /**
     * Set video source
     *
     * @param {Object} src Source object
     * @deprecated since version 5
     * @method Core.prototype.setSrc
     */
    'poster',
    /**
     * Set preload attribute
     *
     * @param {String} val Value for the preload attribute
     * @method Htm5.prototype.setPreload
     */
    'preload',
    /**
     * Set autoplay attribute
     *
     * @param {Boolean} autoplay Value for the autoplay attribute
     * @method setAutoplay
     */
    'autoplay',
    /**
     * Set loop attribute
     *
     * @param {Boolean} loop Value for the loop attribute
     * @method Core.prototype.setLoop
     */
    'loop',
    /**
     * Set desired speed at which the media resource is to play
     *
     * @param {Number} val Speed at which the media resource is to play
     * @method Core.prototype.setPlaybackRate
     */
    'playbackRate'
].forEach(function(prop) {
    Core.prototype['set' + toTitleCase(prop)] = function(v) {
        this.el[prop] = v;
    };
});

// wrap native functions with a function
[
    /**
     * Pause for core
     *
     * @method Core.prototype.pause
     */
    'pause'
].forEach(function(prop) {
    Core.prototype[prop] = function() {
        return this.el[prop]();
    };
});

let videos = {};
var regVideo = function(core) {
    if (typeof videos[core.id] === 'undefined') {
        videos[core.id] = core;
    }
};
var unRegVideo = function(core) {
    if (typeof videos[core.__uuid] !== 'undefined') {
        delete videos[core.__uuid];
    }
};
let index = 0;
var uuid = function() {
    return 'video_' + index++;
};
Core.current = function() {
    return currentVideo;
};
Core.videos = function() {
    return videos;
};

module.exports = Core;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/core/index.js